import { Component } from '@angular/core';

@Component({
    selector: 'platform-error',
    templateUrl: './error.component.html',
})
export class ErrorComponent {}
